import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

export interface ListUsersInput {
  limit?: number;
  offset?: number;
}

interface Dependencies {
  userRepository: IUserRepository;
}

export function createListUsersUseCase({ userRepository }: Dependencies) {
  return async function listUsers(input?: ListUsersInput): Promise<{ data: UserEntity[]; total: number }> {
    return userRepository.list({
      limit: input?.limit,
      offset: input?.offset,
    });
  };
}

